import { default as create } from './create'
import { default as compose } from './compose'

const ion = { create, compose }
export default ion
